// extracted by mini-css-extract-plugin
export default {"loadingWrapper":"loading_loadingWrapper__k-BKA","ldsSpinner":"loading_ldsSpinner__A3jKG","dark":"loading_dark__VcUjW","lds-spinner":"loading_lds-spinner__jQdq7"};